import React, { useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { Form } from '@unform/web';

import { mutate as mutateGlobal } from 'swr';
import api from '../../services/api';
import { useFetch } from '../../hooks/useFetch';
import { useToast } from '../../hooks/toast';

import ButtonPrimaryGree from '../../components/ButtonPrimaryGreen';
import { InputSearch } from '../../components/Form';
import NavbarMenu from '../../components/NavbarMenu';
import ContainerBox from '../../components/ContainerBox';
import ButtonGroupbox from '../../components/ContainerBox/ButtonGroupbox';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';

import { Container, TotalItems } from './styles';

const Classifications = () => {
  const formRef = useRef(null);

  const [page, setPage] = useState(1);
  const [url, setUrl] = useState('/classifications?page=1');
  const [showClassifications, setShowClassifications] = useState(true);

  const { dataList: classifications, loading, totalItems } = useFetch(
    `/classifications?page=${page}`
  );

  const { dataList: searchClassification, loading: loadingSearch } = useFetch(
    url
  );

  const { addToast } = useToast();

  const head = {
    id: 'ID',
    description: 'Descrição',
  };

  const handleClassificationsDelete = useCallback(
    async (id) => {
      try {
        if (
          window.confirm(`Tem Certeza que realmente deseja excluir o registro?`)
        ) {
          await api.delete(`/classifications/${id}`);

          mutateGlobal(`/classifications?page=${page}`);
          mutateGlobal(url);

          addToast({
            type: 'success',
            title: 'Cadastro Excluido com Sucesso',
          });
        } else {
          return;
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao excluir verifique.',
        });
      }
    },
    [addToast, page, url]
  );

  const handleSubmit = useCallback(() => {
    const input = formRef.current.getFieldValue('inputbrand');

    if (!input) {
      setUrl('/classifications?page=1');
      setPage(1);
      setShowClassifications(true);

      return;
    }

    setUrl(`/classificationsearch?search=${input}`);
    setShowClassifications(false);
    formRef.current.reset();
  }, []);

  const handleEnter = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  return (
    <Container>
      <NavbarMenu />
      <ContainerBox title="Tipo - Classificação de ovos">
        <ButtonGroupbox>
          <Link to="/classifications/newedit">
            <ButtonPrimaryGree icon={FiPlus}>Adicionar</ButtonPrimaryGree>
          </Link>

          <Form ref={formRef} onSubmit={() => {}}>
            <InputSearch
              id="inputbrand"
              name="inputbrand"
              autoComplete="off"
              onKeyDown={(e) => handleEnter(e)}
              handleClick={handleSubmit}
            />
          </Form>
        </ButtonGroupbox>

        {showClassifications && loading && <Loading />}

        {showClassifications && !loading && classifications && (
          <>
            <Table
              head={head}
              data={classifications}
              handleDelete={handleClassificationsDelete}
              pathname="/classifications/newedit"
            />
            {totalItems && (
              <TotalItems>
                <span>
                  Total de registro(s): <b>{totalItems}</b>
                </span>
              </TotalItems>
            )}
            {totalItems > 20 && (
              <Pagination
                setPage={setPage}
                currentPage={page}
                totalItems={totalItems}
              />
            )}
          </>
        )}

        {!showClassifications && loadingSearch && <Loading />}

        {!showClassifications && !loadingSearch && searchClassification && (
          <Table
            head={head}
            data={searchClassification}
            handleDelete={handleClassificationsDelete}
            pathname="/classifications/newedit"
          />
        )}
      </ContainerBox>
    </Container>
  );
};

export default Classifications;
